import ViewBase from "../../../../framework/core/mvvm/view_base";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import TextureManager from "../../../../manager/texture_manager";
import { SSL_OP_LEGACY_SERVER_CONNECT } from "constants";
const { ccclass, property } = cc._decorator;




@ccclass
export default class RuleView extends ViewBase {
    @property(cc.Sprite)
    ruleSprs:cc.Sprite[] = []//目前最大就7个

    @property(cc.Node)
    btnItem:cc.Node = null

    @property(cc.Node)
    btnItemParent:cc.Node = null

    @property(cc.ScrollView)
    ruleScrollView:cc.ScrollView = null

    @property(cc.ScrollView)
    itemScrollView:cc.ScrollView = null

    @property(cc.Node)
    gameBtn:cc.Node = null

    @property(cc.Node)
    sysBtn:cc.Node = null

    @property(cc.Node)
    leftNode:cc.Node = null

    @property(SpriteFrameHolder)
    btnSprs:SpriteFrameHolder = null


    gameNames = null
    lastGameName = null //上次的选择
    objByChoose = []
    btnItemObjs = [] //所有item
    gameNameByCount: { [key: string]: number; } = {
        "TM_YXX":2, //暂时不显示彩池的规则
        "TM_TB":3, //暂时不显示彩池的规则
        "TM_LHD":1,
        "TM_DZPK":7, 
        "TM_HJK":2,
        "TM_QZNN":2, 
        "TM_JD":2, 
        "TM_BP":3,
        "TM_CP":1,
        "TM_JK":3,
        "TM_BJL":5,
        "TM_Q2":1,
        "Sys_Exp":1,
        "Sys_Vip":1
    }
    initBtnItems(datas, curGameName, isSys = false){
        let index = 0
        this.gameNames = datas
        for (const gameName of datas) {
            if (this.btnItemObjs[index] == null){
                let node = cc.instantiate(this.btnItem);
                node.parent = this.btnItemParent
                let nameSpr = cc.find("Name", node).getComponent(cc.Sprite)
                let chooseObj = cc.find("ChooseBg", node)
                let chooseNameSpr = cc.find("ChooseBg", node).getComponent(cc.Sprite)
                this.btnItemObjs[index] = {Obj:node, NameSpr:nameSpr, ChooseNameSpr:chooseNameSpr, ChooseObj:chooseObj}
            }
            this.btnItemObjs[index].Obj.active = true
            this.btnItemObjs[index].Obj.name = gameName
            this.btnItemObjs[index].ChooseObj.active = false
            this.btnItemObjs[index].NameSpr.spriteFrame = this.btnSprs.getSpriteFrameByKey(gameName)
            this.btnItemObjs[index].ChooseNameSpr.spriteFrame = this.btnSprs.getSpriteFrameByKey(gameName + "2")
            this.objByChoose[gameName] = this.btnItemObjs[index].ChooseObj
            index += 1
        }

        for (let lastIndex = index; lastIndex <  this.btnItemObjs.length; lastIndex++) {
            this.btnItemObjs[lastIndex].Obj.active = false
            
        }
        this.lastGameName = null
        this.showRule(curGameName)
    }




    showRule(gameName){
        if (this.lastGameName == gameName) { return }
        if (this.lastGameName != null){
            this.objByChoose[this.lastGameName].active = false
        }
        this.objByChoose[gameName].active = true
        this.lastGameName = gameName
        this.ruleScrollView.scrollToTop(0.1)
        for (let index = 0; index < 7; index++) {
            const ruleSpr = this.ruleSprs[index];
            ruleSpr.node.active = false
            if (this.gameNameByCount[gameName] >= (index+1)){
                this.loadSprite(ruleSpr, "image/rule/" + gameName + "_" + (index+1), (error: Error, spr)=>{
                    if(gameName=="TM_CP")
                    {
                        ruleSpr.node.position=new cc.Vec2(180,0)
                    }
                    else
                    {
                        ruleSpr.node.position=new cc.Vec2(0,0)
                    }
                    ruleSpr.spriteFrame = spr
                    ruleSpr.node.active = true
                })
            }

        }

        //需要定位到位置 先做简单的处理
        let index = 0
        for (const gameName of this.gameNames) {
            if (gameName == this.lastGameName){
                break
            }
            index += 1
        }
        if (index > 5){
            this.itemScrollView.scrollToBottom(0)
        }
        else{
            this.itemScrollView.scrollToTop(0)
        }
    }


    changeBtnShow(isGame){
        this.gameBtn.active = isGame
        this.sysBtn.active = !isGame
    }

    onDestroy() {

    }

    onHide() {
        // if (this._spriteMap) {
        //     this._spriteMap.forEach(element => {
        //         if (element) {
        //             let texture = element.getTexture()
        //             element.clearTexture()
        //             cc.loader.release(texture)
        //         }
        //     });
        //     this._spriteMap = null
        // }

        if (this._resMap) {
            this._resMap.forEach(element => {
                cc.loader.releaseRes(element)
            });
            this._resMap = null
        }
    }



}